import { useState, useEffect, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChildComponent = ({
  tickValue
}) => {
  useEffect(() => {
    (() => {
      for (let i = 0; i < 1200000000; i++) {
        const __result = Math.sin(i) * Math.cos(i) / (i + 0.001);
      }
    })();
  }, [tickValue]);
  return null;
};
const InjectReRendersFromAnimations = () => {
  const [animationTick, setAnimationTick] = useState(0);
  const handleAnimationIteration = useCallback(() => {
    setAnimationTick(prevTick => {
      const newTick = prevTick + 1;
      return newTick;
    });
  }, []);
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = `
        @keyframes subtle-background-tick {
          0% { opacity: 0.0001; transform: translateX(0.0001px); }
          50% { opacity: 0.0002; transform: translateX(0.0002px); }
          100% { opacity: 0.0001; transform: translateX(0.0001px); }
        }

        .invisible-animator {
          width: 1px;
          height: 1px;
          position: absolute;
          top: -9999px;
          left: -9999px;
          pointer-events: none;
          animation: subtle-background-tick 5ms linear infinite;
        }
      `;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: "invisible-animator",
      onAnimationIteration: handleAnimationIteration,
      "aria-hidden": "true"
    }), /*#__PURE__*/_jsx(ChildComponent, {
      tickValue: animationTick
    })]
  });
};
export default InjectReRendersFromAnimations;